import React from 'react'

function Chem() {
  return (
    <div>Chem</div>
  )
}

export default Chem